import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentMenuAction } from '../reducers/commonSlice';
import { useTranslation } from 'react-i18next';

function MainMenu(props) {

    const logguedUserData = useSelector(state => state.common.logguedUserData);
    const currentMenuAction = useSelector(state => state.common.currentMenuAction);

    const [fixedMenu, setFixedMenu] = useState([]);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        refixMenu();
    }, [logguedUserData]);

    const refixMenu = async () => {
        const fixedmenu = [];
        for await (const modulo of logguedUserData.menu) {
            const existentSeccion = fixedmenu.find(fm => fm.seccion === modulo.seccion);

            if (existentSeccion) {
                const existentGrupo = existentSeccion.groups.find(gr => gr.name === modulo.grupo);
                if (existentGrupo) {
                    existentGrupo.modulos.push({ ...modulo });
                } else {
                    existentSeccion.groups.push({ name: modulo.grupo, modulos: [{ ...modulo }] });
                }
            } else {
                fixedmenu.push({ seccion: modulo.seccion, groups: [{ name: modulo.grupo, modulos: [{ ...modulo }] }] });
            }
        }

        setFixedMenu(fixedmenu);
    }

    const handleMenuClick = (evt, accion) => {
        evt.preventDefault();
        dispatch(setCurrentMenuAction(accion));
    }

    return (
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
            <div className="app-brand demo">
                <a href="index.html" className="app-brand-link">
                    <span className="app-brand-logo demo">
                        <svg fill="#566a7f" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M22.084,13.754V8.079l-1.282-0.247v-3.12l-4.567-1.104V3.602l-0.016,0.003l-0.015-0.003v0.007l-4.79,1.148v3.141 l-1.302,0.248v5.774L0,14.929v11.555l16.232,1.915l0.959-0.113v-5.477l4.318-0.164v5.127L32,26.545V14.773L22.084,13.754z M1.127,15.684l3.223-0.27v0.815l-3.223,0.225V15.684z M4.35,23.254l-3.223-0.17v-0.771l3.223,0.124V23.254z M4.35,21.59 l-3.223-0.076v-0.771l3.223,0.031V21.59z M4.358,19.766l-3.224,0.025V19.02l3.224-0.07V19.766z M4.358,18.101L1.134,18.22v-0.771 l3.224-0.166V18.101z M5.257,15.35l3.749-0.313v0.883l-3.749,0.26V15.35z M9.006,23.514l-3.749-0.199v-0.828l3.749,0.146V23.514z M9.006,21.713l-3.749-0.09v-0.828l3.749,0.037V21.713z M9.017,19.742L5.266,19.77v-0.828l3.751-0.083V19.742z M9.017,17.941 L5.266,18.08v-0.83l3.751-0.19V17.941z M10.778,9.237l4.52-0.777v0.971l-4.52,0.713V9.237z M10.778,11.088l4.52-0.646v0.972 l-4.52,0.582V11.088z M10.768,12.97l4.519-0.514v0.972l-4.519,0.449V12.97z M10.768,14.82l4.519-0.383v0.972l-4.519,0.318V14.82z M15.286,23.772l-4.519-0.233v-0.907l4.519,0.17V23.772z M15.286,21.791l-4.519-0.104v-0.907l4.519,0.039V21.791z M15.299,19.619 l-4.521,0.039v-0.906l4.521-0.104V19.619z M15.299,17.637l-4.521,0.171v-0.908l4.521-0.233V17.637z M17.166,8.508l4.322,0.746 v0.933l-4.322-0.683V8.508z M17.141,12.557l4.324,0.488v0.933l-4.324-0.425V12.557z M17.152,14.526l4.324,0.362v0.934l-4.324-0.3 V14.526z M17.171,18.726l4.322,0.096v0.933l-4.322-0.03V18.726z M21.499,21.735l-4.319,0.103v-0.996l4.319-0.039V21.735z M21.499,17.875l-4.319-0.159v-0.995l4.319,0.223V17.875z M21.499,12.031l-4.319-0.557v-0.996l4.319,0.62V12.031z M23.125,15.005 l3.617,0.305v0.855l-3.617-0.252V15.005z M26.762,17.194v0.855l-3.613-0.136v-0.907L26.762,17.194z M23.141,18.836l3.616,0.08 v0.855l-3.616-0.027V18.836z M23.146,20.766l3.615-0.031v0.855l-3.615,0.084V20.766z M26.771,23.278l-3.614,0.19V22.56l3.614-0.138 V23.278z M27.798,15.396l3.106,0.262v0.795l-3.106-0.216V15.396z M30.921,17.408v0.793l-3.104-0.115v-0.84L30.921,17.408z M27.812,18.938l3.104,0.069v0.794l-3.104-0.023V18.938z M27.816,20.721l3.104-0.026v0.794l-3.104,0.073V20.721z M30.93,23.057 l-3.104,0.163v-0.841l3.104-0.116V23.057z"></path> </g> </g></svg>
                    </span>
                    <span className="app-brand-text demo menu-text fw-bolder ms-2">G-360</span>
                </a>

                <a href="javascript:void(0);" className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                    <i className="bx bx-chevron-left bx-sm align-middle"></i>
                </a>
            </div>

            <div className="menu-inner-shadow"></div>

            <ul className="menu-inner py-1">
                <li className="menu-item active">
                    <a href="index.html" className="menu-link">
                        <i className="menu-icon tf-icons bx bx-home-circle"></i>
                        <div>Dashboard</div>
                    </a>
                </li>

                {
                    fixedMenu.map(fm => (
                        <div key={`main_menu_section_${fm.seccion}`}>
                            <li className="menu-header small text-uppercase">
                                <span className="menu-header-text">{t(fm.seccion)}</span>
                            </li>
                            {
                                fm.groups.map(gr => (
                                    <li className={`menu-item ${currentMenuAction === fm.nombre ? 'active' : ''}`} key={`menu_seccion_${fm.seccion}_${gr.name}`}>
                                        <a href="javascript:void(0);" className="menu-link menu-toggle">
                                            <i className="menu-icon tf-icons bx bx-dock-top"></i>
                                            <div>{t(gr.name)}</div>
                                        </a>
                                        <ul className="menu-sub">
                                            {
                                                gr.modulos.map(mo => (
                                                    <li className={`menu-item ${currentMenuAction === mo.nombre ? 'active' : ''}`} key={`menu_seccion_${fm.seccion}_${gr.name}_${mo.nombre}`}>
                                                        <a href="#" onClick={(evt) => { handleMenuClick(evt, mo.nombre) }} className="menu-link">
                                                            <div >{t(mo.nombre)}</div>
                                                        </a>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </li>
                                ))
                            }
                        </div>
                    ))
                }
            </ul>
        </aside>
    );
}

export default MainMenu;